const PSEvents = require('PSEvents');
const PSState = require('PSState');
const PSUtils = require('PSUtils');

cc.Class({
    extends: cc.Component,

    properties: {
    },

    onLoad () {
        this.scale = 1;
        this.listener = (data) => this._updateTopMargin(data);
    },

    start () {
        PSEvents.getLastAndSubscribe(PSEvents.GAME_INNTER_CANVAS_SIZE_CHANGED, this.listener);
    },

    onDestroy () {
        PSEvents.unsubscribe(PSEvents.GAME_INNTER_CANVAS_SIZE_CHANGED, this.listener);
    },

    _updateTopMargin(data) {
        const canvasHeigh = cc.view.getVisibleSize().height;
        const footerH = canvasHeigh / 2 - Math.abs(this.node.y);

        const h = PSUtils.convertToGameCanvasHeight(data.topValue);
        const innerScale = (h) / (canvasHeigh - footerH);
        this.scale = Math.max(0.01, (1 - innerScale));

        if (this._isLandscape) {
            this.onLandscape();
        } else {
            this.onPortrait();
        }
    },

    onViewResize(_, aspectRatio) {
        this._isLandscape = aspectRatio > 1;

        this._updateTopMargin(PSState.gameInnerCanvasSize);
    },

    onLandscape() {
        this._isLandscape = true;
        if (this.scale === this.node.scale) {
            return;
        }

        this.node.setScale(this.scale, this.scale);
    },

    onPortrait () {
        this._isLandscape = false;
        if (this.node.scale === 1) {
            return;
        }

        this.node.setScale(1, 1);
    },

});
